﻿import React from 'react';

import { EpiContext } from '../../Shared/Scripts/Store/EpiContext/Types';
import { connect } from 'react-redux';
import VeilederUtstyrsstipendDto from '../Models/VeilederUtstyrsstipendDto';
import { UtstyrsstipendSatser } from '../Utilities/UtstyrsstipendSatserApi';
import { VeilederUtstyrsstipendAppState } from '../Store/index';
import { tilPengerFormat } from '../../Shared/Scripts/Utilities/Formatters';
import ResultatComponent from './ResultatComponent';
import contentResolver from '../../Shared/Scripts/Utilities/EpiContentResolver';

interface EeResultOwnProps {
    eventId: string | null;
}

type EeResultatProps = MapStateToProps & MapDispatchToProps & EeResultOwnProps;

class EeResultatComponent extends React.PureComponent<EeResultatProps> {
    constructor(props: EeResultatProps) {
        super(props);
    }

    render(): JSX.Element | null {
        const { epiContext, satser, locale, eventId } = this.props;

        if (satser === null) {
            return null;
        }

        const stipend = tilPengerFormat(satser.SATS_ST01_UTSTYRSSTIPEND_GRUPPE5_FOM2023, locale);

        return (
            <ResultatComponent
                tittelStipend={contentResolver(epiContext, 'tittelEe')}
                verdi={stipend}
                tekst={contentResolver(epiContext, 'utbetalingEe')}
                utbrettLenke={contentResolver(epiContext, 'utbrettTekstLenkeEe')}
                eventId={eventId}
            />
        );
    }
}
interface MapStateToProps {
    epiContext: EpiContext<VeilederUtstyrsstipendDto>;
    satser: UtstyrsstipendSatser | null;
    locale: string;
}

interface MapDispatchToProps {}

export default connect(
    (state: VeilederUtstyrsstipendAppState): MapStateToProps => {
        return {
            epiContext: state.epiContext,
            satser: state.satser,
            locale: state.epiContext.locale,
        };
    },
)(EeResultatComponent);
